export const LOCATION_REQUIRE_ALWAYS = 'always';
export const LOCATION_REQUIRE_ASK = 'ask';
export const LOCATION_REQUIRE_NEVER = 'never';
